import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c0ca8b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6c0ca8b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0ca8b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0ca8b4')) {
      api.createRecord('6c0ca8b4', component.options)
    } else {
      api.reload('6c0ca8b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c0ca8b4&scoped=true", function () {
      api.rerender('6c0ca8b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/company-supplier/index.vue"
export default component.exports